var map = {
	"./independent/legalStructures": "fccf",
	"./independent/legalStructures.json": "fccf",
	"./independent/registerCourts": "7640",
	"./independent/registerCourts.json": "7640",
	"./locale-ge-DE": "b836",
	"./locale-ge-DE.json": "b836",
	"./locale-zh-EN": "a7d2",
	"./locale-zh-EN.json": "a7d2",
	"./localization": "0fcc",
	"./localization.js": "0fcc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0ed8";